import InfoDetails from 'components/InfoDetails';
import Separator from 'components/Separator';
import './exteriorInfo.scss'

const ExteriorInfo = ({ data }) => {
    return (
        <div className='exterior-info-container'>
            {
                data.exterior_features.length > 0 &&
                <InfoDetails title={'Exterior Features'} items={data.exterior_features} />
            }
            {
                data.lot_features.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Lot Features'} items={data.lot_features} />
                </>
            }
            {
                data.parking_features.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Parking Features'} items={data.parking_features} />
                </>
            }
            {
                (data.exterior_features.length === 0 && 
                data.lot_features.length === 0 && 
                data.parking_features.length === 0) &&
                <div className='no-data'>
                    <p>No Exterior Features</p>
                </div>
            }
        </div>
    )
}


export default ExteriorInfo;